let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fhR3Z"), load("j06N4")]).then(() => parcelRequire('TYUsx'));